export default "__VITE_ASSET__DyG07dlK__"